module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/today-230a85e41ecd09055502e412b02b58d4.png";